"use client";

import type { CSSProperties } from "react";

function SkeletonBar({
  className,
  style,
}: {
  className: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={`rounded bg-contrast/6 shimmer shimmer-bg text-foreground ${className}`}
      style={style}
    />
  );
}

/**
 * Shimmed Jobs section skeleton matching the section-card shell used by the
 * other section skeletons. Two job-row placeholders inside the card body.
 */
export function JobsSkeleton() {
  return (
    <div className="flex flex-col">
      <SkeletonBar className="h-[52px] w-full !rounded-t-md !rounded-b-none" />
      <div className="flex flex-col gap-2 rounded-b-md border border-border bg-surface-elevated p-5">
        {[1, 2].map((n) => (
          <div
            key={n}
            className="flex w-full items-center gap-6 rounded-lg border border-border/50 bg-contrast/1 p-3"
          >
            <div className="flex min-w-0 flex-1 flex-col gap-1.5">
              <div className="flex items-center gap-1.5">
                <SkeletonBar className="h-3.5 w-32" />
                <span className="size-1 shrink-0 rounded-full bg-contrast/15" />
                <SkeletonBar className="h-3.5 w-16 !rounded-full" />
              </div>
              <div className="flex items-center gap-1.5">
                <SkeletonBar className="size-[14px] shrink-0" />
                <SkeletonBar className="h-3 w-36" />
                <span className="size-1 shrink-0 rounded-full bg-contrast/15" />
                <SkeletonBar className="h-3 w-20" />
              </div>
            </div>
            <SkeletonBar className="size-4 shrink-0" />
          </div>
        ))}
      </div>
    </div>
  );
}
